import { render, staticRenderFns } from "./formbuilderLogsWidget.vue?vue&type=template&id=3d9e4680&scoped=true"
import script from "./formbuilderLogsWidget.vue?vue&type=script&lang=js"
export * from "./formbuilderLogsWidget.vue?vue&type=script&lang=js"
import style0 from "./formbuilderLogsWidget.vue?vue&type=style&index=0&id=3d9e4680&prod&lang=scss&scoped=true"
import style1 from "./formbuilderLogsWidget.vue?vue&type=style&index=1&id=3d9e4680&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9e4680",
  null
  
)

export default component.exports